import { render, staticRenderFns } from "./NaturalList.vue?vue&type=template&id=966e3cd8&scoped=true&"
import script from "./NaturalList.vue?vue&type=script&lang=js&"
export * from "./NaturalList.vue?vue&type=script&lang=js&"
import style0 from "./NaturalList.vue?vue&type=style&index=0&id=966e3cd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966e3cd8",
  null
  
)

export default component.exports